import axios from 'axios'

// const url = `http://localhost:4000`
const url = `https://api.careerroshi.com`
// const url = process.env.REACT_APP_BASE_URL || `http://localhost:4000`

export const GetSocCode = async () => {
  let result = await axios.get(`${url}/program/find/soccode`)
  return result.data;
}

export const GenerateConnectLink = async (id) => {
  let result = await axios.post(`${url}/program/connect/stripe/account`, {
    org_id: id
  })
  return result
}

export const LoginConnectAccount = async (id) => {
  let result = await axios.post(`${url}/program/connect/stripe/account/login`, {
    org_id: id
  })
  return result
}

export const ProgramAccess = async (data) => {
  let result = await axios.post(`${url}/program/access`, {
    ...data
  })
  return result
}


export const GetOgranizationByID = async (id) => {
  let result = await axios.get(`${url}/get/org/${id}`)
  return result
}

export const  GetPrgrams = async (org_id, search, limit = 1000, page = 0) => {
    let result = await axios.get(`${url}/programs`, {
      params: { org_id, search, limit, page }
    })
    return result
}

export const GetStats = async (org_id) => {
  let result = await axios.get(`${url}/programs/stats`, {
    params: { org_id }
  })
  return result
}

export const AddProgramAPI = async (data) => {
  let result = await axios.post(`${url}/program/add`, data)
  return result
}

export const UpdateProgramAPI = async (data) => {
  let result = await axios.post(`${url}/program/update`, data)
  return result
}

export const DeleteProgram = async (id) => {
  let result = await axios.delete(`${url}/program/${id}`);
  return result
}

export const GetProgram = async (id) => {
  let result = await axios.get(`${url}/program`, {
    params: { id }
  });
  return result;
}

export const UploadCSV = async (data) => {
  let result = await axios.post(`${url}/program/upload/csv`, data);
  return result;
}

export const UpdateOrgVisibility = async (orgId, hide) => {
  let result = await axios.put(`${url}/organizations/update-organization/${orgId}`, { hide });
  return result;
}
